import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../config/axions.config";
import Swal from "sweetalert2";
import { toast } from "sonner";
import { IoMdClose } from "react-icons/io";
import { showDate } from '../../constant';

const EditCourse = () => {
  let navigate = useNavigate();
  let location = useLocation();
  let data = location.state;
  const [admissionTypeList, setAdminssionTypeList] = useState([]);

  const options = [];
  const [name, setName] = useState(data?.name);
  const [duration, setDuration] = useState(data?.duration);
  const [is_active, setIs_active] = useState(data?.is_active);
  const [tutor, setTutor] = useState(data?.tutor);
  const [base_fee, setBase_fee] = useState(data?.base_fee);
  const [details, setDetails] = useState(data.details);
  const [admissionType, setAdminssionType] = useState(data?.admissionType);
  const [startDate, setStartDate] = useState(data.start_date.split("T")[0]);

  async function updateCourse(e) {

    Swal.fire({
      title: "Update Course?",
      text: "Do you want to Update this Course",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Create."
    }).then(async(result) => {
      if (result.isConfirmed) {
        if(!name || !duration || !base_fee  || !admissionType || !startDate) toast.error("Some fileds are emplty");
        try {
          let responce = await api.patch(`course/${data._id}`,{name, details, is_active, duration, base_fee, tutor, admissionType});
          if(responce.data.status){
            toast.success(responce.data.message)
            navigate("/dashboard/course/");   
          }
          else{
            toast.error(responce.data.message);
          }
        } catch (error) {
          toast.error(error.response.data.message);
          let list = error.response.data.errors || [];
          for(let item of list){
            toast.warning(item.msg)
          }
        }
      }else{
        toast.error("OK! request cancle.")
      }
    });
  }

  async function getAdmissionTypeLIst() {
    try {
      let DBResponse = await api.get("admissionType");
      setAdminssionTypeList(DBResponse?.data.data?.AdmissionTypes);
    } catch (error) {
      toast.error("Admission Type List not Get, Something went Wrong");
    }
  }

  const [tutorFieldValue, setTutorFieldValue] = useState("");
  const handleTutorFileKey = (e) => {
    if (e.key === "Enter") {
      if (tutorFieldValue) {
        tutor.push(tutorFieldValue);
        setTutorFieldValue("");
      } else {
        toast.error("input Language field");
      }
    }
  };
  const handleTutorListItemRemove = (e) => {
    let result = tutor.filter((item) => item !== e.target.id);
    setTutor(result);
  };

  useEffect(() => {
    getAdmissionTypeLIst();
  }, []);

  return (
    <div className="grow ms-0 md:ms-0 lg:ms-56">
      <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
        <nav className="sm:hidden" aria-label="Back">
          <div className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
            <svg
              className="flex-shrink-0 w-5 h-5 mr-1 -ml-1 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            Back
          </div>
        </nav>

        <nav className="hidden sm:flex" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-4">
            <li>
              <div>
                <div className="text-gray-400 hover:text-gray-500">
                  <svg
                    className="flex-shrink-0 w-5 h-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                  </svg>
                  <span className="sr-only">Home</span>
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <div
                  className="ml-4 text-sm text-gray-500 hover:text-gray-700"
                  onClick={() => navigate("/dashboard/course/")}
                >
                  Courses
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <div
                  className="ml-3 text-sm text-gray-500 hover:text-gray-700"
                  aria-current="page"
                >
                  Edit Course
                </div>
              </div>
            </li>
          </ol>
        </nav>

        <hr className="my-5 border-gray-300" />

        <div className="lg:flex lg:items-center lg:space-x-8">
          <div className="lg:flex-1 lg:min-w-0">
            <h1 className="text-2xl font-semibold text-primary-600">Edit Course</h1>
            <div className="mt-2 md:mt-3 sm:flex sm:items-center sm:space-x-6">
              <div className="flex items-center space-x-3">
                <svg
                  className="w-5 h-5 text-gray-500"
                  stroke="currentColor"
                  viewBox="0 0 256 256"
                >
                  <polyline
                    points="80 40 24 128 80 216"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="20"
                  ></polyline>
                  <polyline
                    points="176 40 232 128 176 216"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="20"
                  ></polyline>
                </svg>
                <span className="text-gray-600">Course Id - {data._id}</span>
              </div>

              <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                <svg
                  className="w-5 h-5 text-gray-500"
                  stroke="currentColor"
                  viewBox="0 0 256 256"
                >
                  <rect
                    x="40"
                    y="40"
                    width="176"
                    height="176"
                    rx="8"
                    strokeWidth="20"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  ></rect>
                  <line
                    x1="176"
                    y1="20"
                    x2="176"
                    y2="40"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="20"
                  ></line>
                  <line
                    x1="80"
                    y1="20"
                    x2="80"
                    y2="40"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="20"
                  ></line>
                  <line
                    x1="40"
                    y1="88"
                    x2="216"
                    y2="88"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="20"
                  ></line>
                </svg>
                <span className="text-gray-600">Started - {showDate(data.created_at)}</span>
              </div>
            </div>
          </div>

          <div className="flex items-center mt-5 ml-auto space-x-6 lg:justify-end lg:mt-0 lg:flex-shrink-0">
            <div className="flex items-center space-x-2">
              <label htmlFor="">Course Status</label>
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  checked={is_active}
                  onChange={(e) => setIs_active(e.target.checked)}
                  id="toggleSwitch"
                  tabIndex="0"
                />
                <label htmlFor="toggleSwitch"></label>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 space-y-6">
          <div className="bg-white rounded-lg shadow">
            <div className="px-4 py-3 sm:px-6">
              <div className="flex items-center -ml-2">
                <div
                  title="Back"
                  className="btn-circle"
                  aria-label="Back"
                  data-microtip-position="top"
                  data-target="tooltip"
                  role="button"
                  onClick={() => navigate("/dashboard/course/")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M7 16l-4-4m0 0l4-4m-4 4h18"
                    />
                  </svg>
                </div>

                <h2 className="ml-2 text-lg font-medium leading-6 text-gray-900">
                  Edit Course
                </h2>
              </div>
            </div>

            <div className="px-4 py-5 border-t border-gray-300 sm:px-6">
              <form action={(e)=>updateCourse(e)}>
                
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4">
                <div className="col-span-2 sm:col-span-3 md:col-span-2">
                    <label htmlFor="">
                      Admission Type <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <select
                        onClick={(e) => setAdminssionType(e.target.value)}
                      >
                        
                        {admissionTypeList
                          .filter((item) => item._id === admissionType)
                          .map((item) => 
                          <option key={item._id} value={item._id}>{item.type}</option>)}
                        {admissionTypeList?.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                    <div className="col-span-2 sm:col-span-4 md:col-span-2">
                      <label htmlFor="">
                        Course Name <span className="text-primary-600">*</span>
                      </label>
                      <div className="mt-1">
                        <input
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                <div className="col-span-2 sm:col-span-4 md:col-span-2">
                    <label htmlFor="">
                      Course Duration (in months){" "}
                      <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="number"
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                    <label htmlFor="">
                      Course Fees <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <div className="relative rounded-md shadow-sm">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                          <span className="text-gray-500 sm:text-sm">&#8377;</span>
                        </div>
                        <input
                          type="number"
                          value={base_fee}
                          onChange={(e) => setBase_fee(e.target.value)}
                          required
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                          <span className="text-gray-500 sm:text-sm">RS</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                      <label htmlFor="">
                        Course Detail
                      </label>
                      <div className="mt-1">
                        <textarea name="" id="" value={details} onChange={(e)=>setDetails(e.target.value)} placeholder="" className="resize-y" rows="1"></textarea>
                      </div>
                    </div>

                  <div className="col-span-2 sm:col-span-4 md:col-span-2">
                    <label htmlFor="">
                      Course Tutors <span className="text-primary-600">*</span>
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        value={tutorFieldValue}
                        onChange={(e) => setTutorFieldValue(e.target.value)}
                        onKeyDown={(e) => handleTutorFileKey(e)}
                      />
                    </div>
                    <div className="w-full p-2 my-2 mb-2 flex-1 sm:text-sm rounded-md flex flex-wrap gap-2 overflow-hidden">
                      {tutor?.map((item, index) => (
                        <p
                          key={`${item}-${index}`} // Ensure unique key by combining item and index
                          className="px-2 py-1 items-center gap-1 flex justify-center bg-sky-200  rounded-3xl"
                        >
                          {item}
                          <IoMdClose
                            id={item}
                            onClick={(e) => handleTutorListItemRemove(e)}
                            width={"10px"}
                          />
                        </p>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-end mt-5 space-x-4">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => navigate("/dashboard/course/")}
                  >
                    Back
                  </button>

                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
                
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCourse;
